import React from 'react';
import { Translate } from 'react-localize-redux';
import { humaniseFieldName, imageTypeLabelKey } from './imageMeta';

/**
 * The shot type, named from the eCRF field the image hangs off — not from the metadata
 * blob, which does not carry one. A field this build has no label for still names
 * itself, so a study that adds a fifth shot type shows something rather than a gap.
 */
export default function ShotTypeLabel({ fieldName }: { fieldName: string }) {
    const key = imageTypeLabelKey(fieldName);
    if (!key) return <React.Fragment>{humaniseFieldName(fieldName)}</React.Fragment>;
    return <Translate id={`hospital.quality-check.review.shot-type.${key}`} />;
}
